import { DEV_BUILD_VERSION as g } from "../../constants/chunkError.constants.js";
import { isChunkImportFailure as m } from "./chunkError.helper.js";
import { chunkReloadGuardKey as k } from "@my-medication/e2e-page-objects/selectors";
var E = (r) => !r || r.startsWith("${") ? g : r, p = ({ app: r, buildVersion: s, reportError: u, reload: i }) => {
  const o = k(r), e = E(s);
  let t = !1;
  const l = () => {
    try {
      return window.sessionStorage.getItem(o) === e ? {
        reloading: !1,
        storageBlocked: !1
      } : (window.sessionStorage.setItem(o, e), {
        reloading: !0,
        storageBlocked: !1
      });
    } catch {
      return {
        reloading: !1,
        storageBlocked: !0
      };
    }
  };
  return { recoverFromChunkError: (a, c, { trusted: d = !1 } = {}) => {
    if (!d && !m(a)) return !1;
    if (t) return !0;
    const { reloading: n, storageBlocked: f } = l();
    return u(a, {
      chunkLoadError: !0,
      source: c,
      buildVersion: e,
      reloading: n,
      storageBlocked: f
    }), n && (t = !0, i()), !0;
  } };
};
export {
  p as createChunkRecovery
};

//# sourceMappingURL=chunkRecovery.helper.js.map